export const GET_LOOKUP_SUCCESS = "GET_LOOKUP_SUCCESS";
export const ADD_LOOKUP_SUCCESS = "ADD_LOOKUP_SUCCESS";
export const UPDATE_LOOKUP_SUCCESS = "UPDATE_LOOKUP_SUCCESS";
export const DELETE_LOOKUP_SUCCESS = "DELETE_LOOKUP_SUCCESS";
export const GET_LOOKUPS_SUCCESS = "GET_LOOKUPS_SUCCESS";
